import { Controller } from '@hotwired/stimulus';
import { isMobileViewport } from '../../../utils/customer/is_mobile_viewport';

/**
 * レイアウトコントローラー
 * サイドバーの表示・非表示を切り替える
 */
export default class extends Controller {
  static override targets = ['sidebar', 'toggleIcon'];

  static override values = {
    hamburgerIconUrl: String,
    closeIconUrl: String,
  };

  declare readonly sidebarTarget: HTMLElement;
  declare readonly toggleIconTarget: HTMLImageElement;
  declare readonly hamburgerIconUrlValue: string;
  declare readonly closeIconUrlValue: string;

  declare isSidebarOpen: boolean;

  override connect() {
    this.isSidebarOpen = false;
  }

  override disconnect() {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  }

  /**
   * サイドバーの表示・非表示を切り替えるメソッド
   */
  toggle() {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.updateLayout(this.isSidebarOpen);
  }

  /**
   * レイアウトの状態を更新するメソッド
   */
  private updateLayout(isSidebarOpen: boolean) {
    if (isSidebarOpen) {
      this.sidebarTarget.classList.remove('translate-x-full');
      this.toggleIconTarget.src = this.closeIconUrlValue;
      // 背景（mainコンテンツ）のスクロールを無効化（スマホのみ）
      if (isMobileViewport()) {
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
      }
    } else {
      this.sidebarTarget.classList.add('translate-x-full');
      this.toggleIconTarget.src = this.hamburgerIconUrlValue;
      // 背景（mainコンテンツ）のスクロールを復帰
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }
  }
}
